<template>
  <div v-show="$dados.RODADAS.length != 0">
    <h3 v-show="todasAsRodadas">Ciclos Realizados</h3>
    <div class="table-container table-theme-1">
      <table>
        <thead>
          <tr>
            <th>Ciclo</th>
            <th>Ações</th>
            <th>Aproveitamento</th>
            <th>Qtde Ex.</th>
            <th>Respondidos</th>
            <th>Acertos</th>
            <th>Erros</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in $dados.RODADAS" :key="index" v-show="todasAsRodadas || (record.RODADA == (rodada * 1))">
            <td>{{record.RODADA}}</td>
            <td>
              <div v-show="record.SITUACAO=='Completo'">
                <span v-show='record.ERROS > 0' class="btn btn-primary" @click="executar(record.RODADA, 'revisar')">
                  Revisar
                </span>
                <span v-show='record.ERROS != 1' class="btn btn-primary" @click="executar(record.RODADA, 'repetir')">
                  Refazer
                </span>
              </div>
              <div v-show="record.SITUACAO!='Completo'">
                <span class="btn btn-primary" @click="executar(record.RODADA, 'continuar')">
                  Continuar
                </span>
              </div>
            </td>
            <td>
              <span v-show="record.SITUACAO == 'Completo'">
                {{record.APROVEITAMENTO}}%
              </span>
              <span v-show="record.SITUACAO != 'Completo'">
                {{record.SITUACAO}}
              </span>
            </td>
            <td>{{record.QTDEEXERCICIOS}}</td>
            <td>{{record.QTDERESPOSTAS}}</td>
            <td>{{record.ACERTOS}}</td>
            <td>{{record.ERROS}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
var componentDefinition = {
  props: ['rodada'],
  methods: {
    executar: function (rodada, action) {
      var params = this.$route.params
      var name = this.$route.name.split('-')[0]
      if (action === 'continuar') {
        name += '-PERGUNTA'
        var method
        if (this.rodada) {
          method = 'replace'
          params.refresh = (params.refresh || 0) * 1
          ++params.refresh
          this.$dados.set({
            RESPONDIDA: false
          })
        } else {
          method = 'push'
          params.rodada = rodada
        }
        this.$router[method]({
          name: name,
          params: params
        })
      } else {
        this.$dados.set({
          RESPONDIDA: false
        })
        var endpoint = [
          '/SATACS/ALUNO',
          this.$route.params.idaluno,
          'MATRICULA',
          this.$route.params.idmatricula,
          name,
          'REVISAO',
          'BLOCO',
          this.$route.params.idbloco,
          'RODADA',
          rodada
        ]
        if (action === 'repetir') {
          endpoint.push('REPETIR')
        }
        endpoint = endpoint.join('/')
        this.$requests.post(endpoint).then(response => {
          this.refresh(response.data.rodada)
        })
      }
    },
    refresh: function (rodada) {
      var params = this.$route.params
      var name = this.$route.name.split('-')
      if (name[1]) {
        name = name[0]
      } else {
        name = name + '-PERGUNTA'
        params.rodada = rodada
      }
      this.$router.replace({
        name: name,
        params: params
      })
    }
  },
  computed: {
    todasAsRodadas: function () {
      return !this.rodada
    }
  }
}
export default componentDefinition
</script>
